declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../../services/spinner.service';
import { AppData } from '../../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest } from '../../../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../services/hcp.service';


import * as alertFunctions from '../../../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SavePatientInfoRequest, PatientInfoByFormattedCodeController, UpdatePatientInfoRequest, SaveVendorInfoRequest, SaveMaterialDetailsInfoRequest, MaterialsListController, MaterialsListRequest, SaveMaterialToStoreInfoRequest, SaveNewServiceRequest, GenericProcPostRequest, S_Methods, SaveEditServiceRequest, GenericParams, FTV } from '../../../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../../../models/actor/actor';
import { ActorService } from '../../../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../../../models/master/mastermodel';
import { FDService } from '../../../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgbSearchProviderModal } from '../../../../ivf/ivfworkbench/searchprovider.modal';
import { NgbSearchPatientModal } from '../../../../follow up/counsellingregistry/modal/searchpatient.modal';
import { NgbCameraUploadModal } from './cameraupload.modal';

@Component({
  selector: 'ngbeditservices',
  templateUrl: './editservices.modal.html',
  styleUrls: ['./editservices.modal.scss']
})

export class NgbEditServicesModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;
  public isRequesting: boolean;
  @Input() Code: number;
  @Input() CategoryName: string;
  @Input() BasePrice: number;
  @Input() ServiceName: string;
  @Input() RevenueCategory: string;
  @Input() ServiceType: string;
  @Input() DepartmentCode: number;
  @Input() ServiceCategory: number; 
  @Input() BranchBasePrice: number;
  @Input() SelectedFacilityCodeOld: number;

  public UpdatedCategoryName: string;
  public UpdatedBasePrice: number;
  public UpdatedServiceName: string;
  public UpdatedRevenueCategory: string;
  public UpdatedServiceType: string;
  public UpdatedDepartmentCode: number;
  public UpdatedServiceCategory: number;
  public ActorCode2: number;
  public FacilityCode: number;

  public UpdatedBranchBasePrice: number;
  public UpdatedSelectedFacilityCode: number;

  public ApiResData: ApiResponseModel;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private modalService: NgbModal, private hcpservice: HCPService, private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService) { }

  ngOnInit() {
    this.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.ActorCode2 = AppData.Instance().UserLoginDetails.ActorCode;
    this.UpdatedCategoryName = this.CategoryName;
    this.UpdatedBasePrice = this.BasePrice;
    this.UpdatedServiceName = this.ServiceName;
    this.UpdatedRevenueCategory = this.RevenueCategory;
    this.UpdatedServiceType = this.ServiceType;
    this.UpdatedDepartmentCode = this.DepartmentCode;
    this.UpdatedServiceCategory = this.ServiceCategory;
    this.UpdatedBranchBasePrice = this.BranchBasePrice;
    this.UpdatedSelectedFacilityCode = this.SelectedFacilityCodeOld;
    this.CurrentSaveEditServiceRequest = new SaveEditServiceRequest();
    this.CurrentSaveEditServiceRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.LoadBranchWiseCosts();
  }

  BranchWiseCosts: any[];
  LoadBranchWiseCosts() {
    /// 101029
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    var getReq: GenericParams = new GenericParams();
    getReq.ConditionalOperator = 123456;
    getReq.Params = [
      new FTV('ServiceCode', 'number', this.Code)
    ];
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 123456;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          this.BranchWiseCosts = JSON.parse(data);
          //alert(this.AdmissionHeader2);
          //alert(this.AdmissionHeader2.IsDischargeInitiated);
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  CurrentSaveEditServiceRequest = new SaveEditServiceRequest();
  EditService() {
    var saveReq = new SaveEditServiceRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 30060;
    saveReq.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.ServiceCode = this.Code;
    saveReq.ServiceName = this.UpdatedServiceName;
    saveReq.CategoryName = this.UpdatedCategoryName;
    saveReq.BasePrice = this.UpdatedBasePrice;
    saveReq.BranchPrice = this.UpdatedBranchBasePrice;
    saveReq.BranchCode = this.UpdatedSelectedFacilityCode;

    saveReq.DepartmentCode = 0;
    if (this.UpdatedServiceCategory != null)
      saveReq.ServiceCategory = this.UpdatedServiceCategory;
    else {
      alert(this.ServiceCategory);
      saveReq.ServiceCategory = this.ServiceCategory;
    }
    if (this.UpdatedRevenueCategory != null)
      saveReq.RevenueCategory = this.UpdatedRevenueCategory;
    else {
      saveReq.RevenueCategory = this.RevenueCategory;
    }
    if (this.UpdatedServiceType != null)
      saveReq.ServiceType = this.UpdatedServiceType;
    else {
      saveReq.ServiceType = this.ServiceType;
    }
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 30060;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.LoadBranchWiseCosts();
            //this.activeModal.close();
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  DepartmentName: string;
  Department(event: any) {

    if (event != null) {
      this.UpdatedCategoryName = event;
    }

  }
  public SelectedFacilityCode: number;
  SelectedFacilityName: string;
  Branchdata(event: any) {

    if (event != null) {

      // alert(event);
      this.SelectedFacilityName = event;
    }

  }
  ServiceCategoryName: string;
  ServiceCategoryChange(event: any) {
    //alert(event);
    //alert(this.UpdatedServiceCategory);
    if (event != null) {
      this.UpdatedServiceCategory = event;
    }

  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
}
